export default __webpack_public_path__ + "static/media/interface-17.2d535cd4.png";